<template>
  <div class="d-inline-flex mt-md-2">
    <slot name="icon">
      <cld-image
          :publicId="'/sandkastenliga/dude_' + random"
          :width="56"
          :height="56"
          crop="fill"
          class="p-0 my-auto"/>
    </slot>
    <div class="ps-2 align-text-top">
      <div>
        <slot name="super-title">
          {{ superTitle }}
        </slot>
      </div>
      <slot name="title">
        <span class="h2 h-sakali">{{ title }}</span>
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: String,
    superTitle: String
  },
  computed: {
    random() {
      return Math.floor(Math.random() * 3 + 1);
    }
  }
}
</script>
